<template>
  <div id="app">
    <!-- <keep-alive> -->
      <router-view />
    <!-- </keep-alive> -->
  </div>
</template>
<script>
import Layout from '@/views/layout/Main'
export default {
  name: 'App',
  components: {
    Layout
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: false
    }
  },
  created () {
    this.checkVersion()
    this.initUserInfo()
    let organizetion = JSON.parse(sessionStorage.getItem('organizetionRouterName'))
    console.log(organizetion, '.....organizetion，.........')
    if (organizetion && organizetion.name === 'companyDetail') {
      sessionStorage.setItem('organizetionRouterName', null)
      this.$router.push({ name: 'companyDetail', params: { id: organizetion.id, type: 1 } })
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
      location.reload()
    },
    initUserInfo () {
      // 初始化用户信息和用户菜单
      this.$store.dispatch('fetchUserInfo').then(() => {
        this.$store.dispatch('fetchMenuTree').then(() => {
          this.isRouterAlive = true
          this.$store.dispatch('initMenu')
        })
      })
    },
    checkVersion () {
      if (!this.utils.isChrome()) {
        this.$message.warning('为保证您有更好的使用体验，请使用谷歌浏览器')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/area-base/App.vue